module.exports = __webpack_public_path__ + "static/media/cross-red.afacbda8.svg";